module.exports = __webpack_public_path__ + "static/media/debt.893d0eb2.svg";